/** Compatibility export; the business domain owns this implementation. */
export { EnumMbaAvailability, EnumMbaColor, EnumMbaFitType, EnumMbaMarketplace, EnumMbaPrint, EnumMbaProduct, EnumMbaProductType, EnumMbaPublish, EnumMbaScalingType } from '@domains/upload/shared';
